import { TextareaHTMLAttributes, ReactNode, useState } from "react";
import cn from "classnames";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string | ReactNode;
  id?: string;
  placeholder?: string;
  maxLength?: number;
  labelSize?: "sm" | "base";
  labelClassName?: string;
}

export default function TextArea({
  className,
  label,
  id,
  placeholder,
  maxLength,
  onChange,
  value = "",
  labelSize = "base",
  labelClassName,
  ...props
}: TextAreaProps) {
  const [charCount, setCharCount] = useState(String(value).length);
  const uniqueId =
    id ||
    `textarea-${
      typeof label === "string"
        ? label.toLowerCase().replace(/\s+/g, "-")
        : "custom"
    }`;

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setCharCount(e.target.value.length);
    onChange?.(e);
  };

  return (
    <fieldset className="form-control w-full mb-3">
      {label && (
        <div className={cn("label p-0 min-h-10", labelClassName)}>
          <span className="flex items-center">
            <span
              className={cn(
                "text-gray-800 dark:text-base-content/80 font-medium text-xs",
                labelSize === "sm" ? "md:text-sm" : "md:text-base"
              )}
            >
              {label}
            </span>
          </span>
        </div>
      )}
      <textarea
        id={uniqueId}
        className={cn(
          "textarea textarea-bordered w-full leading-5",
          "focus:outline-none focus:border-blue-500",
          "border-gray-300 dark:border-base-300 bg-base-200",
          "transition-colors",
          className
        )}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={handleChange}
        value={value}
        {...props}
      />
      {maxLength && (
        <div className="text-sm text-base-content/60 text-right mt-1">
          {charCount}/{maxLength}
        </div>
      )}
    </fieldset>
  );
}
